import useEventCallback from '../../../../../hooks/useEventCallback'
import {useThrottle} from '../../../../../hooks/useThrottle'
import type {BuildId} from '../../../../../types'

import {useBuildParametersSubscription} from './useBuildParametersSubscription'
import {useQueryBuildParameters} from './useQueryBuildParameters'
import {useQueryDependenciesParameters} from './useQueryDependenciesParameters'
import {useQueryDependenciesTotalCount} from './useQueryDependenciesTotalCount'

interface Props {
  search: string
  buildId: BuildId
  showFromDependencies: boolean
}

const THROTTLER_TIMEOUT = 2000

export const useQueryMergedBuildParameters = (props: Props) => {
  const {refetch: fetchDependenciesTotalCount, count: dependenciesTotalCount} =
    useQueryDependenciesTotalCount(props)
  const {fetch: fetchDependencies, state: dependenciesParameters} = useQueryDependenciesParameters({
    ...props,
    skip: dependenciesTotalCount === 0,
  })

  const {fetch: fetchParameters, state: buildParameters} = useQueryBuildParameters(props)

  const fetch = useEventCallback(() => {
    fetchDependenciesTotalCount()
    fetchDependencies()
    fetchParameters()
  })

  const throttledFetch = useThrottle(fetch, THROTTLER_TIMEOUT)

  useBuildParametersSubscription(props.buildId, throttledFetch)

  return {
    dependenciesTotalCount,
    dependenciesParameters,
    buildParameters,
  }
}
